import {
  type PimProductImageV11,
  type PimProductV11,
} from '@redteclab/api/clients/bully'

/**
 * Simplify migration to the new object image response format.
 * Under https://jira.shop-apotheke.com/browse/WSPORT-1458 a new image format is introduced.
 * This function returns the images in the new format using the old format as a fallback.
 */
export const productAccessorGetImages = (
  product: PimProductV11,
): PimProductImageV11[] => {
  const { images = [], product_images = [] } = product

  if (product_images.length === 0) {
    return images.map((public_url) => ({
      public_url,
    }))
  }

  return product_images
}
